<template>
	<div class="intro container-fluid">
		<div class="canter">
			<svg id="name" width="892" height="82" viewBox="0 0 892 82" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M48.9 63.5H18.5L12.9 79H3.29999L28.5 9.69998H39L64.1 79H54.5L48.9 63.5ZM46.3 56.1L33.7 20.9L21.1 56.1H46.3Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M71.6828 51.5C71.6828 45.8333 72.8161 40.9 75.0828 36.7C77.3495 32.4333 80.4828 29.1333 84.4828 26.8C88.5495 24.4666 93.1828 23.3 98.3828 23.3C105.116 23.3 110.649 24.9333 114.983 28.2C119.383 31.4666 122.283 36 123.683 41.8H113.883C112.949 38.4666 111.116 35.8333 108.383 33.9C105.716 31.9666 102.383 31 98.3828 31C93.1828 31 88.9828 32.8 85.7828 36.4C82.5828 39.9333 80.9828 44.9666 80.9828 51.5C80.9828 58.1 82.5828 63.2 85.7828 66.8C88.9828 70.4 93.1828 72.2 98.3828 72.2C102.383 72.2 105.716 71.2666 108.383 69.4C111.049 67.5333 112.883 64.8666 113.883 61.4H123.683C122.216 67 119.283 71.5 114.883 74.9C110.483 78.2333 104.983 79.9 98.3828 79.9C93.1828 79.9 88.5495 78.7333 84.4828 76.4C80.4828 74.0666 77.3495 70.7666 75.0828 66.5C72.8161 62.2333 71.6828 57.2333 71.6828 51.5Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M163.025 23.2C167.158 23.2 170.892 24.1 174.225 25.9C177.558 27.6333 180.158 30.2666 182.025 33.8C183.958 37.3333 184.925 41.6333 184.925 46.7V79H175.925V48C175.925 42.5333 174.558 38.3666 171.825 35.5C169.092 32.5666 165.358 31.1 160.625 31.1C155.825 31.1 151.992 32.6 149.125 35.6C146.325 38.6 144.925 42.9666 144.925 48.7V79H135.825V4.99998H144.925V32C146.725 29.2 149.192 27.0333 152.325 25.5C155.525 23.9666 159.092 23.2 163.025 23.2Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M208.89 33.1C210.49 29.9666 212.757 27.5333 215.69 25.8C218.69 24.0666 222.323 23.2 226.59 23.2V32.6H224.19C213.99 32.6 208.89 38.1333 208.89 49.2V79H199.79V24.2H208.89V33.1Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M233.695 51.4C233.695 45.8 234.828 40.9 237.095 36.7C239.361 32.4333 242.461 29.1333 246.395 26.8C250.395 24.4666 254.828 23.3 259.695 23.3C264.495 23.3 268.661 24.3333 272.195 26.4C275.728 28.4666 278.361 31.0666 280.095 34.2V24.2H289.295V79H280.095V68.8C278.295 72 275.595 74.6667 271.995 76.8C268.461 78.8667 264.328 79.9 259.595 79.9C254.728 79.9 250.328 78.7 246.395 76.3C242.461 73.9 239.361 70.5333 237.095 66.2C234.828 61.8666 233.695 56.9333 233.695 51.4ZM280.095 51.5C280.095 47.3666 279.261 43.7666 277.595 40.7C275.928 37.6333 273.661 35.3 270.795 33.7C267.995 32.0333 264.895 31.2 261.495 31.2C258.095 31.2 254.995 32 252.195 33.6C249.395 35.2 247.161 37.5333 245.495 40.6C243.828 43.6666 242.995 47.2666 242.995 51.4C242.995 55.6 243.828 59.2666 245.495 62.4C247.161 65.4666 249.395 67.8333 252.195 69.5C254.995 71.1 258.095 71.9 261.495 71.9C264.895 71.9 267.995 71.1 270.795 69.5C273.661 67.8333 275.928 65.4666 277.595 62.4C279.261 59.2666 280.095 55.6333 280.095 51.5Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M326.973 31.7H315.473V79H306.373V31.7H299.273V24.2H306.373V20.3C306.373 14.1666 307.939 9.69998 311.073 6.89998C314.273 4.03331 319.373 2.59998 326.373 2.59998V10.2C322.373 10.2 319.539 11 317.873 12.6C316.273 14.1333 315.473 16.7 315.473 20.3V24.2H326.973V31.7Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M417.043 29.5C415.11 25.4333 412.31 22.3 408.643 20.1C404.976 17.8333 400.71 16.7 395.843 16.7C390.976 16.7 386.576 17.8333 382.643 20.1C378.776 22.3 375.71 25.5 373.443 29.7C371.243 33.8333 370.143 38.6333 370.143 44.1C370.143 49.5666 371.243 54.3666 373.443 58.5C375.71 62.6333 378.776 65.8333 382.643 68.1C386.576 70.3 390.976 71.4 395.843 71.4C402.643 71.4 408.243 69.3666 412.643 65.3C417.043 61.2333 419.61 55.7333 420.343 48.8H392.543V41.4H430.043V48.4C429.51 54.1333 427.71 59.4 424.643 64.2C421.576 68.9333 417.543 72.7 412.543 75.5C407.543 78.2333 401.976 79.6 395.843 79.6C389.376 79.6 383.476 78.1 378.143 75.1C372.81 72.0333 368.576 67.8 365.443 62.4C362.376 57 360.843 50.9 360.843 44.1C360.843 37.3 362.376 31.2 365.443 25.8C368.576 20.3333 372.81 16.1 378.143 13.1C383.476 10.0333 389.376 8.49998 395.843 8.49998C403.243 8.49998 409.776 10.3333 415.443 14C421.176 17.6666 425.343 22.8333 427.943 29.5H417.043Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M438.675 51.4C438.675 45.8 439.808 40.9 442.075 36.7C444.342 32.4333 447.442 29.1333 451.375 26.8C455.375 24.4666 459.808 23.3 464.675 23.3C469.475 23.3 473.642 24.3333 477.175 26.4C480.708 28.4666 483.342 31.0666 485.075 34.2V24.2H494.275V79H485.075V68.8C483.275 72 480.575 74.6667 476.975 76.8C473.442 78.8667 469.308 79.9 464.575 79.9C459.708 79.9 455.308 78.7 451.375 76.3C447.442 73.9 444.342 70.5333 442.075 66.2C439.808 61.8666 438.675 56.9333 438.675 51.4ZM485.075 51.5C485.075 47.3666 484.242 43.7666 482.575 40.7C480.908 37.6333 478.642 35.3 475.775 33.7C472.975 32.0333 469.875 31.2 466.475 31.2C463.075 31.2 459.975 32 457.175 33.6C454.375 35.2 452.142 37.5333 450.475 40.6C448.808 43.6666 447.975 47.2666 447.975 51.4C447.975 55.6 448.808 59.2666 450.475 62.4C452.142 65.4666 454.375 67.8333 457.175 69.5C459.975 71.1 463.075 71.9 466.475 71.9C469.875 71.9 472.975 71.1 475.775 69.5C478.642 67.8333 480.908 65.4666 482.575 62.4C484.242 59.2666 485.075 55.6333 485.075 51.5Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M533.553 79.9C528.42 79.9 523.753 78.7333 519.553 76.4C515.42 74.0666 512.153 70.7666 509.753 66.5C507.42 62.1666 506.253 57.1666 506.253 51.5C506.253 45.9 507.453 40.9666 509.853 36.7C512.32 32.3666 515.653 29.0666 519.853 26.8C524.053 24.4666 528.753 23.3 533.953 23.3C539.153 23.3 543.853 24.4666 548.053 26.8C552.253 29.0666 555.553 32.3333 557.953 36.6C560.42 40.8666 561.653 45.8333 561.653 51.5C561.653 57.1666 560.386 62.1666 557.853 66.5C555.386 70.7666 552.02 74.0666 547.753 76.4C543.486 78.7333 538.753 79.9 533.553 79.9ZM533.553 71.9C536.82 71.9 539.886 71.1333 542.753 69.6C545.62 68.0666 547.92 65.7666 549.653 62.7C551.453 59.6333 552.353 55.9 552.353 51.5C552.353 47.1 551.486 43.3666 549.753 40.3C548.02 37.2333 545.753 34.9666 542.953 33.5C540.153 31.9666 537.12 31.2 533.853 31.2C530.52 31.2 527.453 31.9666 524.653 33.5C521.92 34.9666 519.72 37.2333 518.053 40.3C516.386 43.3666 515.553 47.1 515.553 51.5C515.553 55.9666 516.353 59.7333 517.953 62.8C519.62 65.8667 521.82 68.1666 524.553 69.7C527.286 71.1666 530.286 71.9 533.553 71.9Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M622.218 24.2V79H613.118V70.9C611.385 73.7 608.951 75.9 605.818 77.5C602.751 79.0333 599.351 79.8 595.618 79.8C591.351 79.8 587.518 78.9333 584.118 77.2C580.718 75.4 578.018 72.7333 576.018 69.2C574.085 65.6666 573.118 61.3666 573.118 56.3V24.2H582.118V55.1C582.118 60.5 583.485 64.6666 586.218 67.6C588.951 70.4666 592.685 71.9 597.418 71.9C602.285 71.9 606.118 70.4 608.918 67.4C611.718 64.4 613.118 60.0333 613.118 54.3V24.2H622.218Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M646.683 34.4C648.549 31.1333 651.283 28.4666 654.883 26.4C658.483 24.3333 662.583 23.3 667.183 23.3C672.116 23.3 676.549 24.4666 680.483 26.8C684.416 29.1333 687.516 32.4333 689.783 36.7C692.05 40.9 693.183 45.8 693.183 51.4C693.183 56.9333 692.05 61.8666 689.783 66.2C687.516 70.5333 684.383 73.9 680.383 76.3C676.449 78.7 672.049 79.9 667.183 79.9C662.449 79.9 658.283 78.8667 654.683 76.8C651.149 74.7333 648.483 72.1 646.683 68.9V79H637.583V4.99998H646.683V34.4ZM683.883 51.4C683.883 47.2666 683.049 43.6666 681.383 40.6C679.716 37.5333 677.449 35.2 674.583 33.6C671.783 32 668.683 31.2 665.283 31.2C661.95 31.2 658.849 32.0333 655.983 33.7C653.183 35.3 650.916 37.6666 649.183 40.8C647.516 43.8666 646.683 47.4333 646.683 51.5C646.683 55.6333 647.516 59.2666 649.183 62.4C650.916 65.4666 653.183 67.8333 655.983 69.5C658.849 71.1 661.95 71.9 665.283 71.9C668.683 71.9 671.783 71.1 674.583 69.5C677.449 67.8333 679.716 65.4666 681.383 62.4C683.049 59.2666 683.883 55.6 683.883 51.4Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M729.061 79.9C723.928 79.9 719.261 78.7333 715.061 76.4C710.928 74.0666 707.661 70.7666 705.261 66.5C702.928 62.1666 701.761 57.1666 701.761 51.5C701.761 45.9 702.961 40.9666 705.361 36.7C707.828 32.3666 711.161 29.0666 715.361 26.8C719.561 24.4666 724.261 23.3 729.461 23.3C734.661 23.3 739.361 24.4666 743.561 26.8C747.761 29.0666 751.061 32.3333 753.461 36.6C755.928 40.8666 757.161 45.8333 757.161 51.5C757.161 57.1666 755.894 62.1666 753.361 66.5C750.894 70.7666 747.528 74.0666 743.261 76.4C738.994 78.7333 734.261 79.9 729.061 79.9ZM729.061 71.9C732.328 71.9 735.394 71.1333 738.261 69.6C741.128 68.0666 743.428 65.7666 745.161 62.7C746.961 59.6333 747.861 55.9 747.861 51.5C747.861 47.1 746.994 43.3666 745.261 40.3C743.528 37.2333 741.261 34.9666 738.461 33.5C735.661 31.9666 732.628 31.2 729.361 31.2C726.028 31.2 722.961 31.9666 720.161 33.5C717.428 34.9666 715.228 37.2333 713.561 40.3C711.894 43.3666 711.061 47.1 711.061 51.5C711.061 55.9666 711.861 59.7333 713.461 62.8C715.128 65.8667 717.328 68.1666 720.061 69.7C722.794 71.1666 725.794 71.9 729.061 71.9Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M817.726 24.2V79H808.626V70.9C806.892 73.7 804.459 75.9 801.326 77.5C798.259 79.0333 794.859 79.8 791.126 79.8C786.859 79.8 783.026 78.9333 779.626 77.2C776.226 75.4 773.526 72.7333 771.526 69.2C769.592 65.6666 768.626 61.3666 768.626 56.3V24.2H777.626V55.1C777.626 60.5 778.992 64.6666 781.726 67.6C784.459 70.4666 788.192 71.9 792.926 71.9C797.792 71.9 801.626 70.4 804.426 67.4C807.226 64.4 808.626 60.0333 808.626 54.3V24.2H817.726Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M839.891 71.5H866.791V79H829.491V71.5L856.091 31.6H829.691V24.2H866.591V31.6L839.891 71.5Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>
				<path
					d="M883.298 15.3C881.565 15.3 880.098 14.7 878.898 13.5C877.698 12.3 877.098 10.8333 877.098 9.09998C877.098 7.36664 877.698 5.89998 878.898 4.69998C880.098 3.49998 881.565 2.89998 883.298 2.89998C884.965 2.89998 886.365 3.49998 887.498 4.69998C888.698 5.89998 889.298 7.36664 889.298 9.09998C889.298 10.8333 888.698 12.3 887.498 13.5C886.365 14.7 884.965 15.3 883.298 15.3ZM887.698 24.2V79H878.598V24.2H887.698Z"
					stroke="white"
					stroke-width="4"
					mask="url(#path-1-outside-1)"
				/>

				<mask
					id="path-1-outside-1"
					maskUnits="userSpaceOnUse"
					x="0.299988"
					y="0.599976"
					width="891"
					height="82"
					fill="black"
				>
					<rect fill="white" x="0.299988" y="0.599976" width="891" height="82" />
				</mask>
			</svg>
			<div class="swipe-in-text">
				<div class="text"><h1>FRONT END WEB DEVELOPER</h1></div>
			</div>
		</div>
	</div>
</template>
<script>
``;
export default {
	mounted() {
		//  const name =document.querySelectorAll("#name path");
		//  for( let i=1; i<name.length;i++){
		//    console.log(`letter:${i} is ${name[i].getTotalLength()}`)
		//  }
	},
};
</script>

<style lang="scss" scoped>
.intro {
	width: 100%;
	height: 100vh;
	background-color: #0d1729;
}

.canter {
	position: absolute;

	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	animation: fade-in 1s ease 7.6s forwards;
}
#name {
	max-width: 100%;
    height: auto;
	animation: fill 4s ease forwards 6.3s;
}

#name path:nth-child(1) {
	stroke-dasharray: 277;
	stroke-dashoffset: 277;
	animation: line-animation 2s ease forwards 2s;
}

#name path:nth-child(2) {
	stroke-dasharray: 331;
	stroke-dashoffset: 331;
	animation: line-animation 2s ease forwards 2.3s;
}
#name path:nth-child(3) {
	stroke-dasharray: 351;
	stroke-dashoffset: 351;
	animation: line-animation 2s ease forwards 2.6s;
}
#name path:nth-child(4) {
	stroke-dasharray: 351;
	stroke-dashoffset: 351;
	animation: line-animation 2s ease forwards 2.9s;
}
#name path:nth-child(5) {
	stroke-dasharray: 259;
	stroke-dashoffset: 259;
	animation: line-animation 2s ease forwards 3.2s;
}
#name path:nth-child(6) {
	stroke-dasharray: 268;
	stroke-dashoffset: 268;
	animation: line-animation 2s ease forwards 3.5s;
}
#name path:nth-child(7) {
	stroke-dasharray: 445;
	stroke-dashoffset: 445;
	animation: line-animation 2s ease forwards 3.8s;
}
#name path:nth-child(8) {
	stroke-dasharray: 259;
	stroke-dashoffset: 259;
	animation: line-animation 2s ease forwards 4.1s;
}
#name path:nth-child(9) {
	stroke-dasharray: 245;
	stroke-dashoffset: 245;
	animation: line-animation 2s ease forwards 4.3s;
}
#name path:nth-child(10) {
	stroke-dasharray: 390;
	stroke-dashoffset: 390;
	animation: line-animation 2s ease forwards 4.6s;
}
#name path:nth-child(11) {
	stroke-dasharray: 299;
	stroke-dashoffset: 299;
	animation: line-animation 2s ease forwards 4.9s;
}
#name path:nth-child(12) {
	stroke-dasharray: 245;
	stroke-dashoffset: 245;
	animation: line-animation 2s ease forwards 5.2s;
}
#name path:nth-child(13) {
	stroke-dasharray: 353;
	stroke-dashoffset: 353;
	animation: line-animation 2s ease forwards 5.5s;
}
#name path:nth-child(14) {
	stroke-dasharray: 253;
	stroke-dashoffset: 253;
	animation: line-animation 2s ease forwards 5.8s;
}
#name path:nth-child(15) {
	stroke-dasharray: 235;
	stroke-dashoffset: 235;
	animation: line-animation 2s ease forwards 6.1s;
}

// ----------------------------

.swipe-in-text {
	position: relative;
	display: inline-block;
	visibility: hidden;
	animation: hidde 0.4s 6.4s forwards;

	&:after {
		display: block;
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		width: 90%;
		bottom: 0;
		z-index: 1;
		background-color: #38deed;
		animation: swipe-in-text 1s ease-out 6.3s forwards;
	}
	.text {
		visibility: hidden;

		animation: showText 1s ease-in 6.6s forwards;
		h1 {
			font-size: 2vw;
			text-transform: uppercase;
			color: rgb(136, 146, 176);
			font-weight: 800;
		}
	}
}
// ----------------------------

@keyframes line-animation {
	0% {
		stroke: rgb(109, 53, 7);
	}
	50% {
		stroke: #38deed;
	}
	100% {
		stroke-dashoffset: 0;
		stroke: #fff;
	}
}

// ----------------------------

@keyframes fill {
	0% {
		fill: transparent;
		stroke: rgb(153, 2, 2);
	}
	100% {
		fill: #fff;
		stroke: #fff;
	}
}

// ----------------------------

@keyframes fade-in {
	0% {
		opacity: 1;
	}
	90% {
		opacity: 0;
	}
	100% {
		opacity: 0;
	}
}

// ----------------------------

@keyframes swipe-in-text {
	0% {
		width: 0%;
		right: 100%;
		left: 0;
	}
	50% {
		width: 100%;
		right: 0%;
		left: 0;
	}
	100% {
		width: 0%;
		left: 100%;
	}
}

// ----------------------------

@keyframes showText {
	from {
		visibility: hidden;
		opacity: 0;
	}
	to {
		visibility: visible;
		opacity: 1;
	}
}

// ----------------------------

@keyframes hidde {
	from {
		visibility: hidden;
	}
	to {
		visibility: visible;
	}
}
</style>
